class CerisePreferredLength extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.form = this.closest('form');
    this.root = this.closest('.shopify-section, dialog, product-card') || this.form;
    this.select = this.querySelector('select');
    this.status = this.querySelector('[data-length-status]');
    this.pending = false;
    if (!this.form || !this.select || !this.root) return;
    this.root.addEventListener('change', (event) => {
      const target = event.target;
      if (target === this.select) {
        this.status.textContent = '';
        this.sync();
      } else if (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) {
        if (target.name.startsWith('Size-') || target.name === 'options[Size]') this.sync(target.value);
      }
    }, { signal });
    this.root.addEventListener('variant:selected', (event) => {
      if (!this.isOwnEvent(event)) return;
      this.pending = true;
      this.sync();
    }, { signal });
    this.root.addEventListener('variant:update', (event) => {
      if (!this.isOwnEvent(event)) return;
      this.pending = false;
      this.sync(event.detail?.resource?.option1 || event.detail?.resource?.options?.[0]);
      if (this.select.value) this.status.textContent = '';
    }, { signal });
    this.form.addEventListener('submit', (event) => this.validate(event), { capture: true, signal });
    this.form.addEventListener('click', (event) => {
      const button = event.target.closest('button, input[type="submit"]');
      if (button && button.type === 'submit') this.validate(event);
    }, { capture: true, signal });
    this.sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  isOwnEvent(event) {
    const source = event.target.closest?.('[data-product-id]');
    return !source || source.dataset.productId === this.dataset.productId;
  }

  currentSize() {
    const picker = this.root.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
    const input = picker?.querySelector('input[name^="Size-"]:checked, select[name="options[Size]"]');
    return input?.value || this.dataset.initialSize;
  }

  sync(size = this.currentSize()) {
    const shortAllowed = ['M', 'L', 'XL', '2XL'].includes(String(size).trim().toUpperCase());
    const shortOption = this.select.querySelector('option[value="60 cm"]');
    shortOption.hidden = !shortAllowed;
    shortOption.disabled = !shortAllowed;
    if (!shortAllowed && this.select.value === '60 cm') {
      this.select.value = '';
      this.status.textContent = this.dataset.error;
    }
    const valid = ['65 cm', '70 cm', '75 cm', '80 cm', '85 cm'].includes(this.select.value)
      || (shortAllowed && this.select.value === '60 cm');
    this.select.setCustomValidity(valid ? '' : this.dataset.error);
    const checkout = this.form.querySelector('[data-cerise-length-checkout]');
    if (checkout) checkout.hidden = !valid || this.pending;
    return valid;
  }

  validate(event) {
    if (this.sync() && !this.pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.pending) this.status.textContent = this.dataset.wait;
    else this.select.reportValidity();
  }
}

if (!customElements.get('cerise-preferred-length')) {
  customElements.define('cerise-preferred-length', CerisePreferredLength);
}
